var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticStyle: { "z-index": "999", background: "rgba(0, 0, 0, 0.03)" } },
      [
        _c(
          "a-card",
          {
            staticStyle: {
              "box-sizing": "border-box",
              "border-radius": "0 !important",
            },
          },
          [
            _c("div", { staticClass: "wps" }, [
              _c(
                "div",
                {
                  staticClass: "biaoti",
                  style: { fontSize: _vm.fontSize + "px" },
                  on: { click: _vm.homepay },
                },
                [
                  _c("div", { staticClass: "boxw" }, [
                    _c("img", {
                      staticStyle: {
                        "margin-top": "-14px",
                        "padding-right": "10px",
                        "margin-left": "10px",
                        width: "65px",
                        height: "60px",
                      },
                      attrs: { src: _vm.httplogo },
                    }),
                  ]),
                  _vm._v(" " + _vm._s(_vm.configdata.projectname) + " "),
                ]
              ),
              _c("div", { staticClass: "ClickMenu" }, [
                _vm.fullPath != "/" && _vm.fullPath != "/register"
                  ? _c(
                      "b",
                      {
                        staticClass: "Menu_b",
                        on: {
                          click: function ($event) {
                            return _vm.Menu(1)
                          },
                        },
                      },
                      [_vm._v("首页")]
                    )
                  : _vm._e(),
                _vm.fullPath != "/" && _vm.fullPath != "/register"
                  ? _c(
                      "b",
                      {
                        staticClass: "Menu_b",
                        on: {
                          click: function ($event) {
                            return _vm.Menu(2)
                          },
                        },
                      },
                      [_vm._v("证书新购")]
                    )
                  : _vm._e(),
                _vm.fullPath != "/" && _vm.fullPath != "/register"
                  ? _c(
                      "b",
                      {
                        staticClass: "Menu_b",
                        on: {
                          click: function ($event) {
                            return _vm.Menu(3)
                          },
                        },
                      },
                      [_vm._v("制图服务")]
                    )
                  : _vm._e(),
                _vm.fullPath != "/" && _vm.fullPath != "/register"
                  ? _c(
                      "b",
                      {
                        staticClass: "Menu_b",
                        on: {
                          click: function ($event) {
                            return _vm.Menu(4)
                          },
                        },
                      },
                      [_vm._v("延期服务")]
                    )
                  : _vm._e(),
                _vm.fullPath != "/" && _vm.fullPath != "/register"
                  ? _c(
                      "b",
                      {
                        staticClass: "Menu_b",
                        on: {
                          click: function ($event) {
                            return _vm.Menu(5)
                          },
                        },
                      },
                      [_vm._v("用户中心")]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "dianhua" }, [
                _c("img", {
                  staticClass: "dianhua_img",
                  attrs: { src: require("@/assets/images/icon_kfdh.png") },
                }),
                _c("div", { staticClass: "dianhua_content" }, [
                  _c(
                    "span",
                    {
                      staticClass: "dianhua_content_span",
                      style: { fontSize: _vm.fontSize + "px" },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.configdata.servicephone)),
                      _c(
                        "i",
                        {
                          staticStyle: {
                            "font-style": "normal",
                            "font-weight": "normal",
                            "font-size": "12px",
                            color: "#000",
                            "margin-left": "10px",
                          },
                        },
                        [_vm._v("(工作日 9:00 ~ 18:00) ")]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }